/**
 * Addendum types for progress note addendums.
 * Addendums correct, clarify, or supplement a finalized (signed) note without modifying the original.
 */

export type AddendumReasonCode = 'typo' | 'clarification' | 'other';

export interface AddendumReasonOption {
  value: AddendumReasonCode;
  label: string;
}

export const ADDENDUM_REASON_OPTIONS: AddendumReasonOption[] = [
  { value: 'typo', label: 'Typo' },
  { value: 'clarification', label: 'Clarification' },
  { value: 'other', label: 'Other' },
];

export interface AddendumLineChange {
  removed?: string;
  added?: string;
}

export interface Addendum {
  id: string;
  label: string;
  authorName: string;
  authorCredentials?: string;
  timestamp: string;
  originalNoteDate: string;
  body: string;
  reasonForChange: AddendumReasonCode;
  lineChanges?: AddendumLineChange[];
  /**
   * Full pre-edit snapshot of the note (all lines), used for contextual
   * diff expansion in the addendum view. When provided alongside afterLines,
   * the view can show collapsed context between changed sections.
   */
  originalLines?: string[];
  /** Full post-edit lines — paired with originalLines for context expansion. */
  afterLines?: string[];
}
